import React from 'react'
//import Extra from '../models/Extra.js';

export default class Bill extends React.Component {
  rentalDays = 0;
  rateCharge = 0;
  totalCharge = 0;
  taxes = [
    //{tax1Amount : 0, tax1Rate : 0, tax1Desc : '', tax1Charge : 0, tax1Type : '', tax2Amount : 0, tax2Rate : 0, tax2Desc : '', tax2Charge : 0, tax2Type : ''}
  ];
  dailyExtras = [
    //{ extraAmount : 0, extraDesc : ''}
  ];

  // Not used yet
  appliedAdjustment = 0;
  totalTaxes = 0;
  totalExtras = 0;
  lateCharge = 0;
  surcharge = 0;
}
